import type { MRT_ColumnDef } from "mantine-react-table-open";
import { MantineRoundedNumberCell } from "../../../../../mantine/mrt/components/cell/MantineRoundedNumberCell";
import { roundedNumericFormatter } from "../../../../../utils/RoundedNumberFormat";
import { roundWithPrecision } from "../../../../../utils/roundWithPrecision";
import type {
  EnergyRevenuesCellCheckStateResponse,
  EnergyRevenuesListResponse
} from "../../../RevenueMonitoring.types";
import { PRECISION_FOR_OUTDATED } from "../../EnergyRevenues.constants";

export function getCalculatedAmountColumn({
  energyRevenuesData
}: {
  energyRevenuesData?: EnergyRevenuesListResponse;
}): MRT_ColumnDef<EnergyRevenuesCellCheckStateResponse> {
  return {
    id: "calculated_amount",
    header: "Zu prüfender Wert",
    accessorFn: (row) => roundWithPrecision(row.calculated_amount),
    Cell: ({ cell, row }) => {
      const value =
        cell.getValue<
          EnergyRevenuesCellCheckStateResponse["calculated_amount"]
        >();
      const periodStart = row.original.period_start;
      const column = row.original.column;
      const currentCalculatedAmount = (energyRevenuesData || []).find(
        (item) => item.period_start === periodStart
      )?.[column];
      const isOutdated =
        roundWithPrecision(
          Number(currentCalculatedAmount),
          PRECISION_FOR_OUTDATED
        ) !== value;
      return (
        <MantineRoundedNumberCell
          value={value}
          warningMessage={
            isOutdated
              ? `Wert hat sich seit der letzten Prüfung geändert (neuer Wert: ${roundedNumericFormatter(currentCalculatedAmount)}). Bitte erneuern Sie die Prüfung über "Aktuelle Erlöse".`
              : undefined
          }
        />
      );
    },
    mantineTableHeadCellProps: {
      className: "th-rightaligned"
    },
    enableEditing: false,
    filterVariant: "range"
  };
}
